import { supabase } from '@/lib/supabaseClient';

export type ReminderType =
  | 'upcoming_shoot'
  | 'payment_pending'
  | 'photo_selection'
  | 'contract_due'
  | 'custom';

export interface CreateReminderParams {
  tenantId: string;
  reminderType?: ReminderType;
  entityType?: string;
  entityId?: string;
  reminderDate: string; // ISO string
  message: string;
}

/**
 * Inserts a reminder into the reminders table.
 * Fire-and-forget — does not throw.
 */
export async function createReminder({
  tenantId,
  reminderType = 'custom',
  entityType,
  entityId,
  reminderDate,
  message,
}: CreateReminderParams): Promise<void> {
  try {
    await supabase.from('reminders').insert({
      tenant_id:     tenantId,
      reminder_type: reminderType,
      entity_type:   entityType ?? null,
      entity_id:     entityId ?? null,
      reminder_date: reminderDate,
      message,
      is_sent:       false,
      is_dismissed:  false,
    });
  } catch {
    // Non-critical — silently ignore
  }
}

/* ─── Date helpers ─────────────────────────────────────────── */

/** Returns an ISO string N days before a given date */
export function daysBefore(dateStr: string, days: number): string {
  const d = new Date(dateStr);
  d.setDate(d.getDate() - days);
  return d.toISOString();
}

/** Returns an ISO string N days after a given date */
export function daysAfter(dateStr: string, days: number): string {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString();
}

/** Returns an ISO string N hours before a given date */
export function hoursBefore(dateStr: string, hours: number): string {
  const d = new Date(dateStr);
  d.setTime(d.getTime() - hours * 3_600_000);
  return d.toISOString();
}

/** Returns an ISO string N hours after a given date */
export function hoursAfter(dateStr: string, hours: number): string {
  const d = new Date(dateStr);
  d.setTime(d.getTime() + hours * 3_600_000);
  return d.toISOString();
}
